<template>
    <router-link
        v-if="componentConfigParams"
        :to="componentConfigParams.to"
        :tag="componentConfigParams.tag"
        :type="componentConfigParams.type"
        :style="styles"
        class="a-home-button"
    >
        {{ $t(componentConfigParams.title) }}
    </router-link>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    name: "AHomeButton",
    props: {
        view: {
            type: String,
            default: ''
        }
    },
    computed: {
        ...mapGetters([
            'getMapConfigProp'
        ]),
        viewConfigParams() {
            return this.getMapConfigProp(`views.${this.view}.header.AHomeButton.params`) || {};
        },
        commonConfigParams() {
            return this.getMapConfigProp('components.AHomeButton.params') || {};
        },
        componentConfigParams() {
            return {
                ...this.viewConfigParams,
                ...this.commonConfigParams
            }
        },
        commonConfigStyles() {
            return this.getMapConfigProp('components.AHomeButton.styles') || {};
        },
        viewConfigStyles() {
            return this.getMapConfigProp(`views.${this.view}.header.AHomeButton.styles`) || {};
        },
        styles() {
            return {
                ...this.commonConfigStyles,
                ...this.viewConfigStyles
            }
        },
    }
}
</script>

<style lang="scss" src="./theme.scss" />